import { Component, Input, ChangeDetectionStrategy } from '@angular/core'

import {
  IRoleplayAssessmentDisplay,
  RoleplayAssessmentData,
} from '../../../services/roleplay'

@Component({
  selector: 'app-roleplay-assessment-display',
  standalone: true,
  imports: [],
  templateUrl: './roleplay-assessment-display.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './roleplay-assessment-display.component.scss',
})
export class RoleplayAssessmentDisplayComponent implements IRoleplayAssessmentDisplay {
  @Input() assessment: RoleplayAssessmentData | undefined
}
